import apisauce from 'apisauce';
import AppConfig from '../../config/AppConfig';
import { getJwtToken } from 'redux/sagaAuth/sagaAuthSaga';

const create = (baseURL = AppConfig.sagaUrl) => {
    const api = apisauce.create({
        // base URL is read from the "constructor"
        baseURL,
        // here are some default headers
        headers: {
            'Cache-Control': 'no-cache',
            'Access-Control-Allow-Origin': '*'
        },
        // 10 second timeout...
        timeout: 60000
    });

    // Force OpenWeather API Key on all requests
    // tslint:disable-next-line
    api.addRequestTransform((request) => {

    });

    const AccountLogin = (username, password, officeId) => api.post('/v1/Account/Login', {
        'Username': username,
        'Password': password,
        'OfficeId': officeId
    });

    const OfficeList = () => api.get('v1/Account/OfficeList');
    const GetUserProfile = (jwtToken) => api.get('v1/Users/GetUserProfile', {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });
    // TODO: detect current UI defaultLanguage and pass it to api endpoint. so that api returns value in the correct defaultLanguage
    const GetProjectList = (jwtToken, branchId, culture) => api.get('v1/Projects/GetProjects?branchId=' + branchId + '&culture=' + culture, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });

    // TODO: detect current UI defaultLanguage and pass it to api endpoint. so that api returns value in the correct defaultLanguage
    const GetProjectDetail = (jwtToken, projectId, branchId, culture, userId) => api.get('v1/Projects/GetProjectDetail/' + projectId + '?branchId=' + branchId + '&culture=' + culture + '&userId=' + userId, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });

    const ProjectDeleteImage = (jwtToken, referenceId, projectImages2Delete, imageType) => api.delete('v1/Projects/DeleteProjectDetailImage/', {
        referenceId,
        imageIds: projectImages2Delete,
        type: imageType,
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

    // TODO: detect current UI defaultLanguage and pass it to api endpoint. so that api returns value in the correct defaultLanguage
    const GetProjectMatrixBatch = (jwtToken, branchId, culture) => api.get('v1/Projects/GetProjectMatrixBatch?branchId=' + branchId + '&culture=' + culture, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });

    const GetAddNewProjectData = (jwtToken, branchId, culture) => api.get('v1/Projects/GetInitialProjectData?branchId=' + branchId + '&culture=' + culture, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });

    const CreateProject = (jwtToken, branchId, project, userId) => api.post('v1/Projects/CreateProject?branchId=' + branchId, {
        'project': project,
        'userId': userId
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

    const CreateProjectUnit = (jwtToken, projectId) => api.get('v1/Projects/CreateProjectUnit?projectId=' + projectId, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });

    const UpdateProject = (jwtToken, culture, project, branchId, userId) => api.put('v1/Projects/UpdateProject?culture=' + culture + '&branchId=' + branchId + '&userId=' + userId, project, {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });

    const UpdateProjectUnits = (jwtToken, projectUnits, projectId, culture, branchId, userId) => api.put(`v1/Projects/UpdateProjectUnits?projectId=${projectId}&culture=${culture}&branchId=${branchId}&userId=${userId}`, projectUnits, {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });

    // const AccountLogin = (username, password, officeId) => api.post('/v1/Account/Login', {
    //     'Username': username,
    //     'Password': password,
    //     'OfficeId': officeId
    // });
    // const ProjectUpdateBatch = (jwtToken, branchId, culture, actionName, propertyList: array, defectList: array, percentage, salesState, salesAgentId) => api.post('v1/Properties/UpdateBatchProperty?branchId=' + branchId + '&culture='+ culture , {

    const ProjectUpdateBatch = (jwtToken, branchId, culture, actionName, propertyList, defectList, percentage, salesState, salesAgentId, price, markUnitIsPercent, userId, projectId) => api.post(`v1/Properties/UpdateBatchProperty?branchId=${branchId}&culture=${culture}&projectId=${projectId}`, {
        'ActionName': actionName,
        'PropertyList': propertyList,
        'DefectList': defectList,
        'Percentage': percentage,
        'SalesState': salesState,
        'AssignToSalesId': salesAgentId,
        'Price': price,
        'MarkUnitIsPercent': markUnitIsPercent,
        'UserId': userId
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const CreateProrjectProperty = (jwtToken, branchId, culture, projectId, unitNumber, unitTypeId, price, minimumPrice, category, userId) => api.post('v1/Properties/CreateProjectProperty?branchId=' + branchId + '&culture=' + culture + '&userId=' + userId, {
        'ProjectId': projectId,
        'UnitNumber': unitNumber,
        'UnitTypeId': unitTypeId,
        'Price': price,
        'MinimumPrice': minimumPrice,
        'Category': category
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const DeleteProject = (jwtToken, projectId, userId, branchId) => api.delete(`v1/Projects/DeleteProject?projectId=${projectId}&userId=${userId}&branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const DeleteProjectUnit = (jwtToken, projectUnitId) => api.delete('v1/Projects/DeleteProjectUnit/' + projectUnitId, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const GetPropertyActions = (jwtToken, propertyId, culture) => api.post(`v1/Properties/GetPropertyActions?culture=${culture}`, {
        PropertyId: propertyId
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const GetOfferDetail = (jwtToken, actionId, branchId, userId, propertyId, culture) => api.get(`v1/OfferOrContract/GetOfferDetail?actionId=${actionId}&branchId=${branchId}&userId=${userId}&propertyId=${propertyId}&culture=${culture}`, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const UpdateOfferDetail = (jwtToken, offerDetail2Update) => api.put(`v1/OfferOrContract/UpdateOfferDetail`, offerDetail2Update, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const DeleteOfferBuyer = (jwtToken, buyerId) => api.delete(`v1/OfferOrContract/DeleteOfferBuyer?buyerId=${buyerId}`, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const GetContactBuyerInformation = (jwtToken, contactId) => api.post(`v1/OfferOrContract/GetContactBuyerInformation`, { contactId }, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestContractDetail = (jwtToken, branchId, culture, contractInput) => api.post('/v1/OfferOrContract/GetContractDetail?branchId=' + branchId + '&culture=' + culture, contractInput, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const CreateOffer = (jwtToken, propertyId, userId, offer2Create) => api.post(`v1/OfferOrContract/CreateOffer`, {
        OfferDetail: offer2Create,
        PropertyId: propertyId,
        UserId: userId
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const UpdateContractDetail = (jwtToken, contractDetail, branchId) => api.post('v1/OfferOrContract/UpdateContractDetail?branchId=' + branchId, contractDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const UpdateContractPaymentBreakdown = (jwtToken, contractBreakDownsDetail, offerId, branchId, culture) => api.post(`v1/OfferOrContract/UpdateContractPaymentBreakDown?offerId=${offerId}&branchId=${branchId}&culture=${culture}`, contractBreakDownsDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const GetAgents = (jwtToken, branchId) => api.get(`v1/Users/GetAgents?branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const GetContractReportText = (jwtToken, textId, editorKey) => api.get('v1/OfferOrContract/GetContractReportText?textId=' + textId + '&editorKey=' + editorKey, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const GetLatestPropertiesView = (jwtToken, userId, branchId, limit, culture) => api.get(`v1/Properties/GetLatestPropertiesViewByUser?userId=${userId}&limit=${limit}&culture=${culture}&branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const UpdatePropertyStatus = (jwtToken, propertyId, status) => api.put('v1/Properties/UpdatePropertyStatus', {
        propertyId,
        status
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const GetMyEnquiries = (jwtToken, userId, culture, propertyId) => api.get(`v1/Enquiries/GetMyEnquiries?userId=${userId}&culture=${culture}&propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const UpdateEnquirySource = (jwtToken, enquiryId, source) => api.put('v1/Enquiries/UpdateEnquirySource', {
        enquiryId,
        updateValue: source
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const UpdateEnquiryStatus = (jwtToken, enquiryId, status) => api.put('v1/Enquiries/UpdateEnquiryStatus', {
        enquiryId,
        updateValue: status
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const CreateEnquiryMemo = (jwtToken, enquiryId, status, memo, userId) => api.post('v1/Enquiries/CreateEnquiryMemo', {
        enquiryId,
        status,
        memo,
        userId
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const UpdateContractText = (jwtToken, contractText) => api.post('v1/OfferOrContract/UpdateContractText', contractText, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const UpdateContractCommission = (jwtToken, contractCommission) => api.post('v1/OfferOrContract/UpdateContractCommission', contractCommission, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const GetDashboardCommission = (jwtToken, userId, branchId, culture) => api.get(`v1/Commission/GetDashboardCommission?userId=${userId}&branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRestoreContract = (jwtToken, historyId, offerId, contractId, action) => api.get(`v1/OfferOrContract/RestoreHistory?historyId=${historyId}&offerId=${offerId}&contractId=${contractId}&action=${action}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRestoreOffer = (jwtToken, historyId, offerId, contractId, action) => api.get(`v1/OfferOrContract/RestoreHistory?historyId=${historyId}&offerId=${offerId}&contractId=${contractId}&action=${action}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetUserDashboard = (jwtToken, userId) => api.get(`v1/Users/GetUserDashboard?userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateDashboardLayoutChanged = (jwtToken, userId, dashboardLayout, selectedDashboard) => api.post(`v1/Users/UpdateDashboardLayoutChanged`, {
        userId,
        dashboardLayout,
        selectedDashboard
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const requestGetEmployeeCommission = (jwtToken, branchId, culture, employeeCommission) => api.post(`v1/Commission/GetEmployeeCommission?branchId=${branchId}&culture=${culture}`, employeeCommission, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestExportAllEmployeeCommission = (jwtToken, branchId, culture, allEmployeeCommission) => api.post(`v1/ExcelReport/ExportAllEmployeeCommission?branchId=${branchId}&culture=${culture}`, allEmployeeCommission, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestInitialCreateOffer = (jwtToken, branchId, userId, propertyId, culture) => api.get(`v1/OfferOrContract/InitialCreateOffer?branchId=${branchId}&userId=${userId}&propertyId=${propertyId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateEmployeeCommission = (jwtToken, branchId, culture, employeeCommission) => api.post(`v1/Commission/GenerateEmployeeCommissionReport?branchId=${branchId}&culture=${culture}`, employeeCommission, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestSearchContact = (jwtToken, searchTerm) => api.get(`v1/Contact/SearchContact?searchTerm=${encodeURI(searchTerm)}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateProjectReport = (jwtToken, branchId, culture, filter, exportType, projectId) => api.post(`v1/Report/GenerateProjectReport?exportType=${exportType}&branchId=${branchId}&culture=${culture}&projectId=${projectId}`, filter, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestCreateProjectEnquiry = (jwtToken, projectEnquiry, branchId) => api.post('v1/Projects/CreateProjectEnquiry?branchId=' + branchId, projectEnquiry, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetSalesCommissionSettings = (jwtToken, branchId) => api.get(`v1/Setting/GetSalesCommissionSetting?branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateSalesCommissionSetting = (jwtToken, branchId, userId, culture, commissionSetting) => api.post(`v1/Setting/SaveSalesCommissionSetting?branchId=${branchId}&culture=${culture}&userId=${userId}`, commissionSetting, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });
    const requestgetAgentPercentCommission = (jwtToken, branchId, salesAgentId) => api.post(`v1/Commission/GetAgentPercentCommission?branchId=${branchId}&salesAgentId=${salesAgentId}`, {}, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePropAndProjectSettings = (jwtToken, branchId, culture, propAndProjectSettingUpdate) => api.post(`v1/Setting/UpdatePropAndProjectSettings?branchId=${branchId}&culture=${culture}`, propAndProjectSettingUpdate, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetAllPropAndProjectSettings = (jwtToken, branchId, culture, settingCommon) => api.post(`v1/Setting/GetAllPropAndProjectSettings?branchId=${branchId}&culture=${culture}`, settingCommon, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateDropdownOptionSettings = (jwtToken, branchId, culture, dropdownSettingUpdate) => api.post(`v1/Setting/UpdateDropdownOptionSettings?branchId=${branchId}&culture=${culture}`, dropdownSettingUpdate, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetEnquirySettings = (jwtToken, branchId, culture, settingCommon) => api.post(`v1/Setting/GetEnquirySettings?branchId=${branchId}&culture=${culture}`, settingCommon, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestInitialPropertyReport = (jwtToken, branchId, culture) => api.get(`v1/Report/InitialPropertyReport?branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateDocumentTemplate = (jwtToken, branchId, culture, documentTemplateUpdate) => api.post(`v1/Setting/UpdateDocumentTemplate?branchId=${branchId}&culture=${culture}`, documentTemplateUpdate, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });


    const requestGeneratePropertyReport = (jwtToken, branchId, culture, selectedFilter, isBCP) => api.post(`v1/Report/GeneratePropertyReport?branchId=${branchId}&culture=${culture}&isBCP=${isBCP}`, selectedFilter, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetMultiLanguage = (jwtToken, branchId, culture) => api.get(`v1/Setting/GetOfficeLanguage?branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetOfficeSettingLanguage = (jwtToken, branchId) => api.get(`v1/Setting/GetOfficeSettingLanguage?branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateDefaultOfficeLanguage = (jwtToken, branchId, culture, id) => api.post(`v1/Setting/UpdateDefaultOfficeLanguage?branchId=${branchId}&culture=${culture}`, id, {

        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });


    const requestGenerateCommissionReport = (jwtToken, branchId, culture, contractId, saleId, exportType, commissionId) => api.post(`v1/Report/GenerateCommissionReport?branchId=${branchId}&culture=${culture}&contractId=${contractId}&saleId=${saleId}&exportType=${exportType}&commissionId=${commissionId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDeleteLanguageOfficeMapping = (jwtToken, branchId, langId, culture) => api.delete(`v1/Setting/DeleteLanguageOfficeMapping?langId=${langId}&branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestCreateLanguageOfficeMapping = (jwtToken, branchId, langId, culture) => api.post(`v1/Setting/CreateLanguageOfficeMapping?langId=${langId}&branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetDeedDetail = (jwtToken, contractId, deedId, branchId, userId, culture) => api.post(`v1/OfferOrContract/GetDeedDetail?contractId=${contractId}&deedId=${deedId}&branchId=${branchId}&userId=${userId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateDeedPayment = (jwtToken, deedPayment, branchId, culture) => api.post(`v1/OfferOrContract/UpdateDeedPayment?branchId=${branchId}&culture=${culture}`, deedPayment, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateDeedDetail = (jwtToken, deedDetail, userId) => api.post(`v1/OfferOrContract/UpdateDeedDetail?userId=${userId}`, deedDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateDeedDescription = (jwtToken, deedDetail, userId) => api.post(`v1/OfferOrContract/UpdateDeedDescription?userId=${userId}`, deedDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetPropertyDescription = (jwtToken, propertyId, userId, branchId) => api.get(`v1/Properties/GetPropertyDescription?propertyId=${propertyId}&branchId=${branchId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateStandardText = (jwtToken, standardText, userId, branchId, propertyId) => api.post(`v1/Properties/UpdateStandardText?branchId=${branchId}&userId=${userId}&propertyId=${propertyId}`, standardText, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePropertyDescription = (jwtToken, propertyDescription, branchId, userId) => api.post(`v1/Properties/UpdatePropertyDescription?branchId=${branchId}&userId=${userId}`, propertyDescription, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetDefaultOfficeSettingLanguage = (jwtToken, branchId, culture) => api.get(`v1/Setting/GetDefaultOfficeSettingLanguage?branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateOfferReport = (jwtToken, branchId, culture, offerId, propertyId) => api.post(`v1/Report/GenerateOfferReport?branchId=${branchId}&culture=${culture}&offerId=${offerId}&propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateContractReport = (jwtToken, branchId, culture, propertyId, contractId) => api.post(`v1/Report/GenerateContractReport?propertyId=${propertyId}&branchId=${branchId}&culture=${culture}&reportId=${contractId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateDeedReport = (jwtToken, branchId, culture, deedId) => api.post(`v1/Report/GenerateDeedReport?branchId=${branchId}&culture=${culture}&reportId=${deedId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOfferDescription = (jwtToken, offerDescription, userId) => api.put(`v1/OfferOrContract/UpdateOfferDescription?userId=${userId}`, offerDescription, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOfferPayment = (jwtToken, branchId, culture, offerPayment, actionId, userId) => api.put(`v1/OfferOrContract/UpdateOfferPayment?branchId=${branchId}&culture=${culture}&actionId=${actionId}&userId=${userId}`, offerPayment, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateMortgageCancelationDate = (jwtToken, cancelDate, offerId, cancelDateText) => api.post(`v1/Loan/UpdateMortgageCancelationDate?offerId=${offerId}`, { cancelDate, cancelDateText }, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOldLoan = (jwtToken, loan, propertyId, parentId, parentType, branchId, culture) => api.post(`v1/Loan/UpdateOldLoan?propertyId=${propertyId}&parentId=${parentId}&parentType=${parentType}&branchId=${branchId}&culture=${culture}`, loan, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestOldLoanTakeOver = (jwtToken, loan, propertyId, parentId, parentType, branchId, culture) => api.post(`v1/Loan/UpdateOldLoanTakeOver?propertyId=${propertyId}&parentId=${parentId}&parentType=${parentType}&branchId=${branchId}&culture=${culture}`, loan, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRemoveTakenLoan = (jwtToken, loanId, propertyId, parentId, parentType, branchId, culture) => api.post(`v1/Loan/RemoveTakenLoan?loanId=${loanId}&propertyId=${propertyId}&parentId=${parentId}&parentType=${parentType}&branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateILSLoan = (jwtToken, ILSloan, branchId, culture) => api.post(`v1/Loan/UpdateILSLoan?branchId=${branchId}&culture=${culture}`, ILSloan, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateNewLoan = (jwtToken, loan, branchId, culture) => api.post(`v1/Loan/UpdateNewLoan?branchId=${branchId}&culture=${culture}`, loan, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRemoveNewLoan = (jwtToken, loanId, parentId, parentType, branchId, culture) => api.post(`v1/Loan/RemoveNewLoan?loanId=${loanId}&parentId=${parentId}&parentType=${parentType}&branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateLoanTitle = (jwtToken, refId, refType, title, loanType) => api.post(`v1/Loan/UpdateLoanTitle?refId=${refId}&refType=${refType}&loanType=${loanType}`, { title }, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateBond = (jwtToken, loan, branchId, culture) => api.post(`v1/Loan/UpdateBonds?branchId=${branchId}&culture=${culture}`, loan, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRemoveBond = (jwtToken, loanId, parentId, parentType, branchId, culture) => api.post(`v1/Loan/RemoveBonds?loanId=${loanId}&parentId=${parentId}&parentType=${parentType}&branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateLoanDate = (jwtToken, refId, refType, contractDate, contractDeedDate, transferDate, previousDeedDueDate, transferDateText) => api.post(`v1/Loan/UpdateLoanDate`, {
        refId, refType, contractDate, contractDeedDate, transferDate, previousDeedDueDate, transferDateText
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const requestGetOfficeSettings = (jwtToken, branchId, culture) => api.get(`v1/Setting/GetOfficeSetting?branchId=${branchId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOfficeDetail = (jwtToken, branchId, culture, officeDetail) => api.put(`v1/Setting/UpdateOfficeDetail?branchId=${branchId}&culture=${culture}`, officeDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOfficeBuyerCosts = (jwtToken, branchId, culture, officeDetail) => api.put(`v1/Setting/UpdateOfficeBuyerCosts?branchId=${branchId}&culture=${culture}`, officeDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOfficeFMR = (jwtToken, branchId, culture, officeDetail) => api.put(`v1/Setting/UpdateOfficeFMR?branchId=${branchId}&culture=${culture}`, officeDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOfficePortal = (jwtToken, branchId, culture, officePortal) => api.put(`v1/Setting/UpdateOfficePortal?branchId=${branchId}&culture=${culture}`, officePortal, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDeleteOfficePortal = (jwtToken, branchId, culture, portalSenderId) => api.delete(`v1/Setting/DeleteOfficePortal?branchId=${branchId}&culture=${culture}&portalSenderId=${portalSenderId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestCreateOfficePortal = (jwtToken, branchId, culture, portalSender) => api.post(`v1/Setting/CreateOfficePortal?branchId=${branchId}&culture=${culture}}`, portalSender, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOfficeDarkpool = (jwtToken, branchId, culture, officeDetail) => api.put(`v1/Setting/UpdateOfficeDarkpool?branchId=${branchId}&culture=${culture}}`, officeDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestAdvanceProjectSearch = (jwtToken, branchId, culture, advansearch) => api.post(`v1/Projects/AdvanceProjectSearch?branchId=${branchId}&culture=${culture}`, advansearch, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetEnquiry = (jwtToken, branchId, culture, userId) => api.get(`v1/Enquiries/GetEnquiry?branchId=${branchId}&culture=${culture}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });
    const requestGetContacts = (jwtToken, branchId, culture, userId) => api.get(`v1/Contact/GetContacts?branchId=${branchId}&userId=${userId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateEnquiryBatch = (jwtToken, branchId, culture, updateEnquiryBatch) => api.post(`v1/Enquiries/UpdateEnquiryBatch?branchId=${branchId}&culture=${culture}`, updateEnquiryBatch, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestExportEnquiryReport = (jwtToken, branchId, culture, enquiryReportInput) => api.post(`v1/Report/GenerateEnquiryReport?branchId=${branchId}&culture=${culture}`, enquiryReportInput, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });
    const requestUpdateContactBatch = (jwtToken, branchId, culture, contactBatchData) => api.put(`v1/Contact/UpdateContactBatch?branchId=${branchId}&culture=${culture}`, contactBatchData, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetContactDetail = (jwtToken, branchId, culture, contactId) => api.get(`v1/Contact/GetContactDetail?branchId=${branchId}&culture=${culture}&contactId=${contactId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateContactDetail = (jwtToken, contact, branchId, culture) => api.post(`v1/Contact/UpdateContactDetail?branchId=${branchId}&culture=${culture}`, contact, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRemoveContactDetail = (jwtToken, contactId) => api.post(`v1/Contact/RemoveContactDetail?contactId=${contactId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateContactReport = (jwtToken, branchId, culture, contactIds, userId) => api.post(`v1/Report/GenerateContactReport?branchId=${branchId}&culture=${culture}`, {
        userId, contactIds
    }, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });

    const requestGetLeads = (jwtToken, branchId, culture, userId) => api.get(`v1/Lead/GetLeads?branchId=${branchId}&culture=${culture}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateLeadBatch = (jwtToken, branchId, culture, updateLeadBatch) => api.post(`v1/Lead/UpdateLeadBatch?branchId=${branchId}&culture=${culture}`, updateLeadBatch, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateLeadReport = (jwtToken, branchId, culture, leadReportInput) => api.post(`v1/Report/GenerateLeadReport?branchId=${branchId}&culture=${culture}`, leadReportInput, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetEnquiryDetail = (jwtToken, branchId, culture, enquiryId) => api.get(`v1/Enquiries/GetEnquiryDetail?branchId=${branchId}&culture=${culture}&enquiryId=${enquiryId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRemoveILSLoan = (jwtToken, loanId, branchId, culture, parentId, parentType) => api.post(`v1/Loan/RemoveILSLoan?loanId=${loanId}&branchId=${branchId}&culture=${culture}&parentId=${parentId}&parentType=${parentType}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateEnquiryDetail = (jwtToken, enquiryInfomation) => api.post(`v1/Enquiries/UpdateEnquiryDetail`, enquiryInfomation, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetLeadDetail = (jwtToken, branchId, culture, leadId, propertyId, userId) => api.get(`v1/Lead/GetLeadDetail?branchId=${branchId}&culture=${culture}&leadId=${leadId}&propertyId=${propertyId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateLeadDetail = (jwtToken, leadDetail) => api.post(`v1/Lead/UpdateLeadDetail?`, leadDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRemoveLeadDetail = (jwtToken, leadId) => api.post(`v1/Lead/RemoveLeadDetail?leadId=${leadId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestFindMatchProperty = (jwtToken, branchId, culture, enquiryId) => api.get(`v1/Enquiries/FindMatchProperty?branchId=${branchId}&culture=${culture}&enquiryId=${enquiryId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestCreateLeadByEnquiry = (jwtToken, branchId, culture, enquiryId, propertyId, userId) => api.post(`v1/Lead/CreateLeadByEnquiry?branchId=${branchId}&culture=${culture}&enquiryId=${enquiryId}&propertyId=${propertyId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });


    const requestSagaUISendEmail = (jwtToken, branchId, emailData) => api.post(`v1/Email/SagaUISendEmail?branchId=${branchId}`, emailData, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetContactProperties = (jwtToken, branchId, culture, contactId) => api.get(`v1/Contact/GetPropertyOfContact?branchId=${branchId}&culture=${culture}&contactId=${contactId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetContactRelatedProperties = (jwtToken, branchId, culture, contactId) => api.get(`v1/Contact/GetContactRelatedProperties?branchId=${branchId}&culture=${culture}&contactId=${contactId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateProjectSentToWeb = (jwtToken, branchId, projectId, isSentToWeb, userId, culture) => api.post(`v1/Projects/UpdateProjectSentToWeb?branchId=${branchId}&projectId=${projectId}&isSentToWeb=${isSentToWeb}&userId=${userId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetuserCalendar = (jwtToken, branchId, culture, userId, selectedMonth, selectedYear, dataType) => api.get(`v1/Users/GetuserCalendar?branchId=${branchId}&userId=${userId}&culture=${culture}&selectedMonth=${selectedMonth}&selectedYear=${selectedYear}&dataType=${dataType}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetEmployees = (jwtToken, branchId, userId, culture) => api.get(`v1/Setting/GetEmployees?branchId=${branchId}&userId=${userId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRestoreDeed = (jwtToken, historyId, offerId, contractId, action, deedId) => api.get(`v1/OfferOrContract/RestoreHistory?historyId=${historyId}&offerId=${offerId}&contractId=${contractId}&action=${action}&deedId=${deedId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetPreviewTextTemplate = (jwtToken, pdfReportId, refId, propertyId, parentType, culture, branchId) => api.get(`v1/OfferOrContract/GetPreviewTextTemplate?pdfReportId=${pdfReportId}&refId=${refId}&propertyId=${propertyId}&type=${parentType}&culture=${culture}&branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });


    const requestGetEmployeeDetail = (jwtToken, branchId, userId, culture) => api.get(`v1/Setting/GetEmployeeDetail?branchId=${branchId}&userId=${userId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });
    const requestSaveEmployeeDetail = (jwtToken, employeeDetail, branchId) => api.post(`v1/Setting/SaveEmployeeDetail?branchId=${branchId}`, employeeDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestSaveEmployeeEducationDetail = (jwtToken, usersEducations) => api.post(`v1/Setting/SaveEmployeeEducationDetail?`, usersEducations, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePropertiesOnWeb = (jwtToken, branchId, userId) => api.post(`v1/Setting/UpdatePropertiesOnWeb?branchId=${branchId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestAutoGenerateUserName = (jwtToken, branchId) => api.get(`v1/Setting/AutoGenerateUserName?branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateEmployeeStatus = (jwtToken, employeeStatus, branchId) => api.post(`v1/Setting/UpdateEmployeeStatus?branchId=${branchId}`, employeeStatus, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetEmployeeStatusProperties = (jwtToken, branchId, userId) => api.get(`v1/Setting/GetEmployeeStatusProperties?branchId=${branchId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDeleteEnquiry = (jwtToken, enquiryId) => api.delete(`v1/Enquiries/DeleteEnquiry?enquiryId=${enquiryId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDeleteContacts = (jwtToken, branchId, userId, culture, contactIds) => api.post(`v1/Contact/DeleteContacts?branchId=${branchId}&userId=${userId}&culture=${culture}`, contactIds, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });


    const requestDeleteEnquiries = (jwtToken, branchId, userId, culture, enquiryIds) => api.post(`v1/Enquiries/DeleteEnquiries?branchId=${branchId}&userId=${userId}&culture=${culture}`, enquiryIds, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDeleteLeads = (jwtToken, branchId, userId, culture, leadIds) => api.post(`v1/Lead/DeleteLeads?branchId=${branchId}&userId=${userId}&culture=${culture}`, leadIds, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestSaveUserColumnSetting = (jwtToken, userId, settingType, selectedColumns) => api.post(`v1/Setting/SaveUserColumnSetting?userId=${userId}&type=${settingType}`, selectedColumns, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetPropertyList = (jwtToken, userId, branchId, culture) => api.get(`v1/Properties/GetPropertyList?branchId=${branchId}&userId=${userId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGeneratePropertyListReport = (jwtToken, branchId, culture, propertyIds, userId) => api.post(`v1/Report/GeneratePropertyListReport?branchId=${branchId}&userId=${userId}&culture=${culture}`, propertyIds, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateBatchPropertyList = (jwtToken, branchId, culture, batchProperty) => api.post(`v1/Properties/UpdateBatchPropertyList?branchId=${branchId}&culture=${culture}`, batchProperty, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateSellerAndBuyerInformations = (jwtToken, branchId, culture, userId, sellerAndBuyerInfo) => api.post(`v1/OfferOrContract/UpdateSellerAndBuyerInformations?branchId=${branchId}&culture=${culture}&userId=${userId}`, sellerAndBuyerInfo, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetPropertyDetail = (jwtToken, branchId, culture, propertyId, userId, category) => api.get(`v1/Properties/GetPropertyDetail?branchId=${branchId}&culture=${culture}&propertyId=${propertyId}&userId=${userId}&category=${category}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetProjectUnits = (jwtToken, projectId) => api.get(`v1/Projects/GetProjectUnits?projectId=${projectId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetLeadsByProperty = (jwtToken, branchId, culture, userId, propertyId) => api.get(`v1/Lead/GetLeadsByProperty?branchId=${branchId}&culture=${culture}&userId=${userId}&propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateProperty = (jwtToken, branchId, culture, propertyDetail, userId) => api.post(`v1/Properties/UpdatePropertyDetail?branchId=${branchId}&culture=${culture}&userId=${userId}`, propertyDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePropertySendToWeb = (jwtToken, branchId, propertyId, userId, isOnWeb, culture) => api.post(`v1/Properties/UpdatePropertySendToWeb?branchId=${branchId}&userId=${userId}&propertyId=${propertyId}&isOnweb=${isOnWeb}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePortalSenderForProperty = (jwtToken, branchId, propertyId, portalId, userId, isSelected) => api.post(`v1/Properties/UpdatePortalSenderForProperty?branchId=${branchId}&userId=${userId}&propertyId=${propertyId}&portalId=${portalId}&isSelected=${isSelected}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePropertyArchive = (jwtToken, branchId, propertyId, userId) => api.post(`v1/Properties/UpdatePropertyArchive?branchId=${branchId}&userId=${userId}&propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDeleteProperty = (jwtToken, branchId, propertyId, userId) => api.delete(`v1/Properties/DeleteProperty/${propertyId}?branchId=${branchId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateDynamicPropertyReport = (jwtToken, branchId, culture, reportId, methodName, propertyId) => {
        let url = '';
        if (methodName.indexOf('?') > -1) {
            url = `v1/Report/${methodName}&propertyId=${propertyId}&branchId=${branchId}&culture=${culture}&reportId=${reportId}`;
        }
        else {
            url = `v1/Report/${methodName}?propertyId=${propertyId}&branchId=${branchId}&culture=${culture}&reportId=${reportId}`;
        }
        return api.post(url, null, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            }
        });
    };

    const requestGetPropertyPicturesAndFiles = (jwtToken, branchId, culture, propertyId, userId) => api.get(`v1/Properties/GetPropertyPicturesAndFiles?propertyId=${propertyId}&branchId=${branchId}&userId=${userId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateWaterMarkSetting = (jwtToken, branchId, propertyId, userId, watermarkSetting) => api.post(`v1/Properties/UpdateWaterMarkSetting?propertyId=${propertyId}&branchId=${branchId}&userId=${userId}`, watermarkSetting, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetPropertyPicturesWithWaterMark = (jwtToken, branchId, propertyId, userId) => api.get(`v1/Properties/GetPropertyPicturesWithWaterMark?propertyId=${propertyId}&branchId=${branchId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePropertyPicturesAndFiles = (jwtToken, branchId, propertyId, userId, pictureAndFiles) => api.post(`v1/Properties/UpdatePropertyPicturesAndFiles?propertyId=${propertyId}&branchId=${branchId}&userId=${userId}`, pictureAndFiles, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRotatePropertyPictures = (jwtToken, branchId, propertyId, userId, angle, pictureIds) => api.post(`v1/Properties/RotatePropertyPictures?propertyId=${propertyId}&branchId=${branchId}&userId=${userId}&rotate=${angle}`, pictureIds, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePortalSenderForProject = (jwtToken, branchId, projectId, portalId, userId, isSelected) => api.post(`v1/Projects/UpdatePortalSenderForProject?projectId=${projectId}&branchId=${branchId}&userId=${userId}&portalId=${portalId}&isSelected=${isSelected}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateCategory = (jwtToken, propertyId, userId) => api.post(`v1/Properties/UpdateCategory?propertyId=${propertyId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestConvertPropertyType = (jwtToken, propertyId, userId, propertyTypeId) => api.post(`v1/Properties/ConvertResidentialToCommercialOrCommercialToResidential?propertyId=${propertyId}&userId=${userId}&dropdownOptionsId=${propertyTypeId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateUserDefaultList = (jwtToken, userId, defaultList) => api.put(`v1/Setting/UpdateUserDefaultList?userId=${userId}&defaultList=${defaultList}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDuplicateProperty = (jwtToken, branchId, culture, propertyId, userId) => api.post(`v1/Properties/DuplicateProperty?propertyId=${propertyId}&branchId=${branchId}&userId=${userId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetOwnersInformation = (jwtToken, branchId, propertyId, userId) => api.get(`v1/Properties/GetOwnersInformation?propertyId=${propertyId}&userId=${userId}&branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdateOwnersInformation = (jwtToken, branchId, ownerDetail, propertyId, userId) => api.post(`v1/Properties/UpdateOwnersInformation?propertyId=${propertyId}&userId=${userId}&branchId=${branchId}`, ownerDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetPropertyActivityLogs = (jwtToken, propertyId) => api.get(`v1/Properties/GetPropertyActivityLogs?propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestCreateOrUpdatePropertyActivityLog = (jwtToken, propertyActivityDetail) => api.post(`v1/Properties/CreateOrUpdatePropertyActivityLog`, propertyActivityDetail, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRemovePropertyActivityLog = (jwtToken, activityLogId, propertyId) => api.delete(`v1/Properties/RemovePropertyActivityLog?activityLogId=${activityLogId}&propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetpropertyPortals = (jwtToken, branchId, propertyId) => api.get(`v1/Properties/GetpropertyPortals?branchId=${branchId}&propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });
    const requestGetPropertyDocument = (jwtToken, branchId, propertyId) => api.get(`v1/Properties/GetPropertyDocument?propertyId=${propertyId}&branchId=${branchId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestUpdatePropertyDocument = (jwtToken, branchId, userId, propertyId, documents) => api.post(`v1/Properties/UpdatePropertyDocument?propertyId=${propertyId}&userId=${userId}&branchId=${branchId}`, documents, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRemoveDocument = (jwtToken, branchId, userId, propertyId, referenceId, actionId, documentType) => api.post(`v1/Properties/RemoveDocument?propertyId=${propertyId}&userId=${userId}&branchId=${branchId}&referenceId=${referenceId}&actionId=${actionId}&documentType=${documentType}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDuplicateOffer = (jwtToken, branchId, userId, propertyId, offerId) => api.post(`v1/Properties/DuplicateOffer?propertyId=${propertyId}&userId=${userId}&branchId=${branchId}&offerId=${offerId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDownloadPropertyFile = (jwtToken, propertyFileId) => api.post(`v1/Report/DownloadPropertyFile?propertyFileId=${propertyFileId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetFmrDetailResponse = (jwtToken, mainRegId) => api.get(`v1/Fmr/GetFmrDetailResponse?mainRegId=${mainRegId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetProjectPortals = (jwtToken, branchId, projectId) => api.get(`v1/Projects/GetProjectPortals?branchId=${branchId}&projectId=${projectId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGenerateSaleReport = (jwtToken, branchId, culture, saleReportInput, userId, exportType) => api.post(`v1/Report/GenerateSaleReport?userId=${userId}&branchId=${branchId}&exportType=${exportType}&culture=${culture}`, saleReportInput, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetPropertyLoans = (jwtToken, propertyId, culture) => api.get(`v1/Properties/GetPropertyLoans?propertyId=${propertyId}&culture=${culture}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetPropertyLoanDetail = (jwtToken, branchId, culture, propertyId, loanId) => api.get(`v1/Properties/GetPropertyLoanDetail?&branchId=${branchId}&culture=${culture}&propertyId=${propertyId}&loanId=${loanId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });


    const requestSavePropertyLoan = (jwtToken, branchId, userId, culture, propertyId, mortgage) => api.post(`v1/Properties/SavePropertyLoan?&branchId=${branchId}&culture=${culture}&propertyId=${propertyId}&userId=${userId}`, mortgage, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });


    const requestRemovePropertyLoan = (jwtToken, branchId, culture, propertyId, loanId) => api.post(`v1/Properties/RemovePropertyLoan?&branchId=${branchId}&culture=${culture}&propertyId=${propertyId}&loanId=${loanId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });


    const requestUpdatePropertyLoanIsSent = (jwtToken, propertyId, loanId, isSent) => api.post(`v1/Properties/UpdatePropertyLoanIsSent?propertyId=${propertyId}&loanId=${loanId}&isSent=${isSent}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestGetpropertyHistories = (jwtToken, branchId, culture, propertyId) => api.get(`v1/Properties/GetpropertyHistories?branchId=${branchId}&culture=${culture}&propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestRestorePropertyHistory = (jwtToken, branchId, propertyId, propertyShwId, userId) => api.post(`v1/Properties/RestorePropertyHistory?branchId=${branchId}&propertyId=${propertyId}&propertyShwId=${propertyShwId}&userId=${userId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestAddPropertyViews = (jwtToken, userId, branchId, culture, propertyId) => api.post(`v1/Properties/AddPropertiesView?userId=${userId}&branchId=${branchId}&culture=${culture}&propertyId=${propertyId}`, null, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    const requestDownloadPropertyPictures = (jwtToken, branchId, propertyId, propertyPictureIds) => api.post(`v1/Properties/DownloadPropertyPictures?branchId=v1/Properties/DownloadPropertyPictures?branchId=${branchId}&propertyId=${propertyId}`, propertyPictureIds, {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    });

    return {
        axios: api.axiosInstance,
        AccountLogin,
        OfficeList,
        GetUserProfile,
        GetProjectList,
        GetProjectDetail,
        ProjectDeleteImage,
        GetProjectMatrixBatch,
        ProjectUpdateBatch,
        GetAddNewProjectData,
        CreateProject,
        CreateProrjectProperty,
        CreateProjectUnit,
        UpdateProject,
        UpdateProjectUnits,
        DeleteProject,
        DeleteProjectUnit,
        GetPropertyActions,
        GetOfferDetail,
        UpdateOfferDetail,
        DeleteOfferBuyer,
        GetContactBuyerInformation,
        requestContractDetail,
        CreateOffer,
        UpdateContractDetail,
        UpdateContractPaymentBreakdown,
        GetAgents,
        GetContractReportText,
        UpdateContractText,
        GetLatestPropertiesView,
        UpdatePropertyStatus,
        GetMyEnquiries,
        UpdateEnquirySource,
        UpdateEnquiryStatus,
        CreateEnquiryMemo,
        UpdateContractCommission,
        GetDashboardCommission,
        requestRestoreContract,
        requestRestoreOffer,
        requestGetUserDashboard,
        requestUpdateDashboardLayoutChanged,
        requestGetEmployeeCommission,
        requestExportAllEmployeeCommission,
        requestInitialCreateOffer,
        requestGenerateEmployeeCommission,
        requestSearchContact,
        requestGenerateProjectReport,
        requestCreateProjectEnquiry,
        requestGetSalesCommissionSettings,
        requestUpdateSalesCommissionSetting,
        requestgetAgentPercentCommission,
        requestUpdatePropAndProjectSettings,
        requestGetAllPropAndProjectSettings,
        requestUpdateDropdownOptionSettings,
        requestGetEnquirySettings,
        requestInitialPropertyReport,
        requestGeneratePropertyReport,
        requestUpdateDocumentTemplate,
        requestGetMultiLanguage,
        requestGetOfficeSettingLanguage,
        requestUpdateDefaultOfficeLanguage,
        requestGenerateCommissionReport,
        requestDeleteLanguageOfficeMapping,
        requestCreateLanguageOfficeMapping,
        requestGetDeedDetail,
        requestUpdateDeedPayment,
        requestUpdateDeedDetail,
        requestUpdateDeedDescription,
        requestGetPropertyDescription,
        requestUpdateStandardText,
        requestUpdatePropertyDescription,
        requestGetDefaultOfficeSettingLanguage,
        requestGenerateOfferReport,
        requestGenerateContractReport,
        requestGenerateDeedReport,
        requestUpdateOfferDescription,
        requestUpdateOfferPayment,
        requestUpdateMortgageCancelationDate,
        requestUpdateOldLoan,
        requestUpdateILSLoan,
        requestOldLoanTakeOver,
        requestRemoveTakenLoan,
        requestUpdateNewLoan,
        requestRemoveNewLoan,
        requestUpdateLoanTitle,
        requestUpdateBond,
        requestRemoveBond,
        requestUpdateLoanDate,
        requestGetOfficeSettings,
        requestUpdateOfficeDetail,
        requestUpdateOfficeBuyerCosts,
        requestUpdateOfficeFMR,
        requestUpdateOfficePortal,
        requestDeleteOfficePortal,
        requestCreateOfficePortal,
        requestUpdateOfficeDarkpool,
        requestAdvanceProjectSearch,
        requestGetEnquiry,
        requestGetContacts,
        requestUpdateEnquiryBatch,
        requestExportEnquiryReport,
        requestUpdateContactBatch,
        requestGetContactDetail,
        requestUpdateContactDetail,
        requestRemoveContactDetail,
        requestGenerateContactReport,
        requestGetLeads,
        requestUpdateLeadBatch,
        requestGenerateLeadReport,
        requestGetEnquiryDetail,
        requestRemoveILSLoan,
        requestUpdateEnquiryDetail,
        requestGetLeadDetail,
        requestUpdateLeadDetail,
        requestRemoveLeadDetail,
        requestSagaUISendEmail,
        requestFindMatchProperty,
        requestCreateLeadByEnquiry,
        requestGetContactProperties,
        requestGetContactRelatedProperties,
        requestUpdateProjectSentToWeb,
        requestGetuserCalendar,
        requestRestoreDeed,
        requestGetPreviewTextTemplate,
        requestGetEmployees,
        requestGetEmployeeDetail,
        requestSaveEmployeeDetail,
        requestSaveEmployeeEducationDetail,
        requestUpdatePropertiesOnWeb,
        requestAutoGenerateUserName,
        requestUpdateEmployeeStatus,
        requestGetEmployeeStatusProperties,
        requestDeleteEnquiry,
        requestDeleteContacts,
        requestDeleteEnquiries,
        requestDeleteLeads,
        requestSaveUserColumnSetting,
        requestGetPropertyList,
        requestGeneratePropertyListReport,
        requestUpdateBatchPropertyList,
        requestUpdateSellerAndBuyerInformations,
        requestGetPropertyDetail,
        requestGetProjectUnits,
        requestGetLeadsByProperty,
        requestUpdateProperty,
        requestUpdatePropertySendToWeb,
        requestUpdatePortalSenderForProperty,
        requestUpdatePropertyArchive,
        requestDeleteProperty,
        requestGenerateDynamicPropertyReport,
        requestGetPropertyPicturesAndFiles,
        requestUpdateWaterMarkSetting,
        requestGetPropertyPicturesWithWaterMark,
        requestUpdatePropertyPicturesAndFiles,
        requestRotatePropertyPictures,
        requestUpdatePortalSenderForProject,
        requestUpdateCategory,
        requestConvertPropertyType,
        requestUpdateUserDefaultList,
        requestDuplicateProperty,
        requestGetOwnersInformation,
        requestUpdateOwnersInformation,
        requestGetPropertyActivityLogs,
        requestCreateOrUpdatePropertyActivityLog,
        requestRemovePropertyActivityLog,
        requestGetpropertyPortals,
        requestGetFmrDetailResponse,
        requestGetPropertyDocument,
        requestUpdatePropertyDocument,
        requestRemoveDocument,
        requestDuplicateOffer,
        requestDownloadPropertyFile,
        requestGetProjectPortals,
        requestGenerateSaleReport,
        requestGetpropertyHistories,
        requestRestorePropertyHistory,
        requestGetPropertyLoans,
        requestGetPropertyLoanDetail,
        requestSavePropertyLoan,
        requestRemovePropertyLoan,
        requestUpdatePropertyLoanIsSent,
        requestAddPropertyViews,
        requestDownloadPropertyPictures
    };
};

// let's return back our create method as the default.
export default create();



// WEBPACK FOOTER //
// ./src/helpers/sagaApi/SagaApi.ts